import React, { Fragment } from "react";

import Form from "./Form";
import HelpBlock from "../component/HelpBlock";
import { Create as RaCreate } from "react-admin";

const Create = ({ ...props }) => {
  return (
    <Fragment>
      <HelpBlock
        elevation={1}
        resource="technical-report-final-outputs"
        context="create"
      />
      <RaCreate {...props}>
        <Form />
      </RaCreate>
    </Fragment>
  );
};

export default Create;
